<template>
  <div class="headerContainer">
    <div class="logo">
      <div
        class="leftLogo selfAlignCenter"
        v-html="require('@/../public/img/vue_svg/verkehrsservice_hessen_relaunch.svg')"
        style="width:205px;"
      ></div>

      <div
        class="selfAlignCenter"
        v-if="device !== 'XS'"
        v-html="require('@/../public/img/vue_svg/logo_hessen_mobil_2022.svg')"
        style="width:300px;"
      ></div>

      <!-- <div
        class="selfAlignCenter"
        v-if="device !== 'XS'"
        style="width:242px;"
      >
      <img src="@/../public/img/Hessen-Mobil-Logo_242x54.png" alt="logo">
      </div> -->

    </div>
    <div class="notification selfAlignCenter cursor-pointer" v-if="device === 'XS'">
      <div class="notificationContainer">
        <SVGIcon name="notifcation_off" @click.native="newstickerOpen = true"/>
        <!-- Anzahl MELDUNGEN unten rechts -->
        <div
          class="notification-count colorWhite backgroundRed borderRadius10 fontweight600 textcenter"
          v-if="newstickerMeldungen.length !== 0"
        >{{newstickerMeldungen.length}}</div>
      </div>
      <Newsticker v-if="newstickerOpen" @close="newstickerOpen=false"/>
    </div>
  </div>
</template>

<script>
import Newsticker from './Newsticker.vue';
export default {
  name: 'Header',
  components: {
    Newsticker
  },
  data: function() {
    return {
      newstickerOpen: false
    };
  },
  computed: {
    newstickerMeldungen() {
      return this.$store.state.newstickerMeldungen;
    },
    device() {
      return this.$store.state.device;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.headerContainer {
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
@media (min-width: 769px) {
  .headerContainer {
    height: 100px;
  }
}
.logo {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px;
}
.leftLogo {
  margin-left: 60px;
}
@media (max-width: 768px) {
  .leftLogo {
    margin-left: 20px;
    margin-top: 10px;
  }
}
.notification {
  width: calc(2 / 12 * 100vw + 10px);
  position: relative;
}
.notificationContainer {
  width: 36px;
  position: relative;
}
.notification-count {
  position: absolute;
  top: -5px;
  right: -5px;
  padding: 2.5px;
  height: 20px;
  width: 20px;
  line-height: 1.25;
}
</style>
